module.exports = __webpack_public_path__ + "img/guide.1768119790257.png";